import AntBadge, { type BadgeProps as AntBadgeProps } from "antd/lib/badge";
import { JSX } from "react";

export type BadgeProps = AntBadgeProps;

interface BadgeComponent {
    (props: BadgeProps): JSX.Element;
    Ribbon: typeof AntBadge.Ribbon;
}

export const Badge: BadgeComponent = (props: BadgeProps) => <AntBadge {...props} />;

Badge.Ribbon = AntBadge.Ribbon;
